import React from 'react';

const LearnDetail = ({ detail }) => {
    return (
        <div className="card md:w-48 md:h-52 dark:bg-[#182233] bg-white shadow-lg">
            <figure className="px-10 pt-5">
                <div className="avatar">
                    <div className="md:w-12  rounded-full">
                        <img src={detail.img} />
                    </div>
                </div>
            </figure>
            <div className="mt-8 items-center text-center">
                <h2 className="text-center text-lg font-bold text-primary dark:text-slate-200">{detail.name}</h2>
                <p className='text-[14px] text-gray-500 dark:text-slate-200'>{detail.description}</p>
            </div>
        </div>
    );
};

export default LearnDetail;